export const URL = {
  TELL_ME_ABOUT_DISPLAY_EXAMPLE_OF_FISHERY_PRODUCT:
    'https://www.caa.go.jp/policies/policy/food_labeling/information/pamphlets/pdf/01_s-foodlabel200330.pdf',
};
